import styled from '@emotion/styled';

export const Svg = styled.svg`
  display: inherit;
  vertical-align: top;
`;
